
export default function TrustedBy() {
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Trusted by
          </h2>
        </div>

        <div className="flex justify-center items-center">
          <img 
            src="/assets/images/nvidia-logo.gif"
            alt="NVIDIA"
            className="h-16 object-contain grayscale hover:grayscale-0 transition-all duration-300"
          />
        </div>
      </div>
    </section>
  );
}
